/**
 * Which of the platform's two sides a route belongs to.
 *
 * The same SPA serves both: the customer-facing DMA dashboard, rooted at
 * `/dashboard` or `/company/:id/:name/dashboard`, and the public-database /
 * legacy tree rooted at `/`, whose company pages are `/company/:id/:name`.
 * Anything that needs to know which side the user is on — the workspace
 * dropdown, the internal-tools side switch — reads it from here so the
 * controls can never disagree about the current side.
 */

/**
 * True when `pathname` is on the dashboard side.
 *
 * Requires a whole lowercase `dashboard` path segment, so a company name
 * segment that only contains the word (`/company/1/dashboard-systems`) stays
 * on the database side.
 */
export function isDashboardPathname(pathname: string): boolean {
  return /\/dashboard(\/|$)/.test(pathname);
}
